<div class="cron-editor-container">
    <lib-custom-cron-editor [formControl]="cronForm" [options]="cronOptions"></lib-custom-cron-editor>
    <button (click)="showExpression = true" mat-flat-button color="primary">Generate Expression</button>
    <span *ngIf="showExpression">Cron Expression: <b>{{cronForm.value}}
            <button mat-icon-button [cdkCopyToClipboard]="cronForm.value"
                (cdkCopyToClipboardCopied)="onExpressionCopy($event)">
                <span class="material-icons copy-btn">content_copy</span>
            </button>
        </b></span>
</div>